'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (value) {
  var symbol = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '$';
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var thousandSeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ',';
  var decimalSeparator = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '.';

  if (!value) return value;

  if (value.indexOf(decimalSeparator) > -1) {
    var decimalIndex = value.indexOf(decimalSeparator);
    if (decimalIndex === value.length - precision - 1) {
      return _accounting2.default.formatMoney(value, symbol, precision, thousandSeparator, decimalSeparator);
    } else if (decimalIndex === value.length - precision) {
      return _accounting2.default.formatMoney(value, symbol, precision - 1, thousandSeparator, decimalSeparator);
    } else if (decimalIndex < value.length - precision - 1) {
      return value.substring(0, value.indexOf(decimalSeparator) + precision + 1);
    }
  } else {
    return _accounting2.default.formatMoney(value, symbol, 0, thousandSeparator);
  }
  return value;
};

var _accounting = require('accounting');

var _accounting2 = _interopRequireDefault(_accounting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./src/v2/helpers/currencyHelper.js
// module id = 1709
// module chunks = 0